var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Divider',{attrs:{"dashed":""}},[_c('span',{staticClass:"divider-text"},[_vm._v("广告投放汇总")])]),_c('Table',{attrs:{"stripe":"","size":"small","data":_vm.adList,"columns":_vm.dataColumns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }